import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./modules/creators/creators.module').then(
        (m) => m.CreatorsModule
      ),
  },
  {
    path: 'makerspace',
    loadChildren: () =>
      import('./modules/makerspace/makerspace.module').then(
        (m) => m.MakerspaceModule
      ),
  },
  {
    path: 'battery-tech',
    loadChildren: () =>
      import('./modules/battery-tech/battery-tech.module').then(
        (m) => m.BatteryTechModule
      ),
  },
  {
    path: 'packaging',
    loadChildren: () =>
      import('./modules/packaging/packaging.module').then(
        (m) => m.PackagingModule
      ),
  },
  {
    path: 'printing-service',
    loadChildren: () =>
      import('./modules/printing-service/printing-service.module').then(
        (m) => m.PrintingServiceModule
      ),
  },
  {
    path: 'printing',
    loadChildren: () =>
      import('./modules/printing-service/printing-service.module').then(
        (m) => m.PrintingServiceModule
      ),
  },
  {
    path: '3d-printing',
    loadChildren: () =>
      import('./modules/three-d-printing/three-d-printing.module').then(
        (m) => m.ThreeDPrintingModule
      ),
  },
  {
    path: 'designers',
    loadChildren: () =>
      import('./modules/designer/designer.module').then(
        (m) => m.DesignerModule
      ),
  },
  {
    path: 'publishing',
    loadChildren: () =>
      import('./modules/publishing/publishing.module').then(
        (m) => m.PublishingModule
      ),
  },
  {
    path: 'creators',
    loadChildren: () =>
      import('./modules/creators/creators.module').then(
        (m) => m.CreatorsModule
      ),
  },
  {
    path: 'document',
    loadChildren: () =>
      import('./modules/document/document.module').then(
        (m) => m.DocumentModule
      ),
  },
  {
    path: 'documents',
    loadChildren: () =>
      import('./modules/document/document.module').then(
        (m) => m.DocumentModule
      ),
  },
  {
    path: 'architects',
    loadChildren: () =>
      import('./modules/architects/architects.module').then(
        (m) => m.ArchitectsModule
      ),
  },
  {
    path: 'builders',
    loadChildren: () =>
      import('./modules/builders/builders.module').then(
        (m) => m.BuildersModule
      ),
  },
  {
    path: 'home',
    loadChildren: () =>
      import('./modules/home/home.module').then((m) => m.HomeModule),
  },
  {
    path: 'about',
    loadChildren: () =>
      import('./modules/about/about.module').then((m) => m.AboutModule),
  },
  {
    path: 'contact',
    loadChildren: () =>
      import('./modules/contact/contact.module').then((m) => m.ContactModule),
  },
  {
    path: 'support',
    loadChildren: () =>
      import('./modules/support/support.module').then((m) => m.SupportModule),
  },
  {
    path: 'terms',
    loadChildren: () =>
      import('./modules/terms/terms.module').then((m) => m.TermsModule),
  },
  {
    path: 'privacy',
    loadChildren: () =>
      import('./modules/privacy/privacy.module').then((m) => m.PrivacyModule),
  },
  {
    path: 'payment-confirmation',
    loadChildren: () =>
      import('./modules/payment-confirmation/payment-confirmation.module').then(
        (m) => m.PaymentConfirmationModule
      ),
  },
  {
    path: '**',
    loadChildren: () =>
      import('./modules/page-not-found/page-not-found.module').then(
        (m) => m.PageNotFoundModule
      ),
  },
];

const routerOptions: ExtraOptions = {
  anchorScrolling: 'enabled',
};

@NgModule({
  imports: [RouterModule.forRoot(routes, routerOptions)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
